export default "__VITE_ASSET__Biib2xWr__"